<script setup lang="ts">
  import { computed } from 'vue';
  import { HoverListTooltip } from '@/shared/ui';

  interface DirectoryModule {
    id: number;
    name: string;
  }

  const props = defineProps<{
    modules?: DirectoryModule[];
  }>();

  // The backend already sorts the modules by name; reordering here would hide a
  // regression on either side.
  const modules = computed(() => props.modules ?? []);

  const hasModules = computed(() => modules.value.length > 0);

  const label = computed(() =>
    modules.value.length === 1 ? '1 módulo' : `${modules.value.length} módulos`
  );

  const title = computed(() =>
    modules.value.length === 1 ? 'Módulo (1)' : `Módulos (${modules.value.length})`
  );

  const items = computed(() => modules.value.map((module) => ({ id: module.id, text: module.name })));
</script>

<template>
  <HoverListTooltip
    v-if="hasModules"
    :label="label"
    :title="title"
    :items="items"
    test-id="document-modules-tooltip"
  />
  <span v-else>-</span>
</template>
